<script setup lang="ts"></script>

<template>
  <icon name="lucide:plus" />
</template>

<style scoped></style>
